export const localization = {
  pt: {
    asideMenu: {
      dataConsumption: {
        title: 'Visão geral: Relatório de consumo',
        subtitle: 'Acompanhe o consumo do seu plano',
      },
       advancedDeuConsumption: {
        title: 'Detalhes de consumo das suas métricas',
        subtitle: 'Veja os dados detalhados de consumo do seu contrato',
      },
      aiTokenConsumption: {
        title: 'Consumo Tokens de IA',
        subtitle: 'Veja os dados de consumo de Tokens de IA',
      },
      dauConsumption: {
        title: 'Consumo de DAUs',
        subtitle: 'Veja os detalhes do consumo de DAUs',
      },
      deuConsumption: {
        title: 'Consumo de DEUs',
        subtitle: 'Veja os detalhes do consumo de DEUs',
      },
      agentConsumption: {
        title: 'Consumo de atendentes',
        subtitle: 'Veja os dados de consumo de atendentes acionados',
      },
      sessionConsumption: {
        title: 'Consumo de conversas via WhatsApp',
        subtitle: 'Veja os dados de consumo de conversas via WhatsApp',
      },
      mauMsgConsumption: {
        title: 'Consumo de MAUs e Mensagens trafegadas',
        subtitle: 'Visualize os dados de consumo de usuários ativos mensais e mensagens trafegadas',
      },
      meuMsgConsumption: {
        title: 'Consumo de MEUs e Mensagens ativas',
        subtitle: 'Visualize os dados de consumo de usuários engajados mensais e mensagens ativas',
      },
      mauConsumption: {
        title: 'Consumo de MAUs',
        subtitle: 'Visualize os dados de consumo de usuários ativos mensais',
      },
      meuConsumption: {
        title: 'Consumo de MEUs e Mensagens ativas',
        subtitle: 'Visualize os dados de consumo de usuários engajados mensais e mensagens ativas',
      },
      msgConsumption: {
        title: 'Consumo de Mensagens',
        subtitle: 'Visualize os dados de consumo de mensagens',
      },
    },
  },
  en: {
    asideMenu: {
      dataConsumption: {
        title: 'Overview: Usage report',
        subtitle: 'Track your plan\'s usage information',
      },
       advancedDeuConsumption: {
        title: 'Metric Consumption Details',
        subtitle: 'View detailed consumption data for your contract',
      },
      aiTokenConsumption: {
        title: 'AI Tokens Consumption',
        subtitle: 'View AI Token consumption data',
      },
      dauConsumption: {
        title: 'DAU usage',
        subtitle: 'View DAU usage details',
      },
      deuConsumption: {
        title: 'DEU usage',
        subtitle: 'View DEU usage details',
      },
      agentConsumption: {
        title: 'Usage per agents',
        subtitle: 'Check your usage details per activated agents',
      },
      sessionConsumption: {
        title: 'Usage per conversation via WhatsApp',
        subtitle: 'Check your usage details per WhatsApp conversation',
      },
      mauMsgConsumption: {
        title: 'MAU usage and Exchanged messages',
        subtitle: 'View monthly active user and exchanged message usage data',
      },
      meuMsgConsumption: {
        title: 'MEU usage and Proactive messages',
        subtitle: 'View monthly engaged user and proactive message usage data',
      },
      mauConsumption: {
        title: 'Usage per MAUs',
        subtitle: 'Check your usage details per monthly active users',
      },
      meuConsumption: {
        title: 'MEU usage and Proactive messages',
        subtitle: 'View monthly engaged user and proactive message usage data',
      },
      msgConsumption: {
        title: 'Usage per Messages',
        subtitle: 'Check your usage details per messages',
      },
    },
  },
  es: {
    asideMenu: {
      dataConsumption: {
        title: 'Visión general: Reporte de consumo',
        subtitle: 'Sigue el consumo de tu plan',
      },
       advancedDeuConsumption: {
        title: 'Detalles de consumo de sus métricas',
        subtitle: 'Ver datos detallados de consumo de su contrato',
      },
      aiTokenConsumption: {
        title: 'Consumo de Tokens de IA',
        subtitle: 'Ver los datos de consumo de Tokens de IA',
      },
      dauConsumption: {
        title: 'Uso de DAU',
        subtitle: 'Ver detalles del uso de DAU',
      },
      deuConsumption: {
        title: 'Uso de DEU',
        subtitle: 'Ver detalles del uso de DEU',
      },
      agentConsumption: {
        title: 'Consumo de asistentes',
        subtitle: 'Ver los datos de consumo de asistentes activados',
      },
      sessionConsumption: {
        title: 'Consumo de conversaciones vía WhatsApp',
        subtitle: 'Ver los datos de consumo de conversaciones vía WhatsApp',
      },
      mauMsgConsumption: {
        title: 'Uso de MAU y Mensajes intercambiados',
        subtitle: 'Visualiza los datos de uso de usuarios activos mensuales y de mensajes intercambiados',
      },
      meuMsgConsumption: {
        title: 'Uso de MEU y Mensajes proactivos',
        subtitle: 'Visualiza los datos de uso de usuarios comprometidos mensuales y de mensajes proactivos',
      },
      mauConsumption: {
        title: 'Consumo de MAUs',
        subtitle: 'Ver los datos de consumo de usuarios activos mensuales',
      },
      meuConsumption: {
        title: 'Uso de MEU y Mensajes proactivos',
        subtitle: 'Visualiza los datos de uso de usuarios comprometidos mensuales y de mensajes proactivos',
      },
      msgConsumption: {
        title: 'Consumo de Mensajes',
        subtitle: 'Visualize os dados de consumo de Mensajes',
      },
    },
  },
};